
import { Card } from "@/components/ui/card";

interface WhySectionProps {}

const WhySection = ({}: WhySectionProps) => {
  return (
    <section className="px-4 py-16 bg-gradient-to-b from-corporate-primary-25 to-white">
      <div className="max-w-4xl mx-auto">
        <Card className="p-8 border-none shadow-xl bg-gradient-to-r from-corporate-primary-100 to-corporate-primary-75 text-white">
          <h2 className="text-3xl font-bold text-center mb-3">Why We're Here</h2>
          <div className="w-24 h-1 bg-corporate-secondary-100 mx-auto mb-8"></div>
          <p className="text-white/90 text-center text-lg leading-relaxed">
            Many traders missed out on significant gains during the last crypto bull run due to 
            limited time, market knowledge, or high-risk emotional trades. METRADE offers a 
            solution: cutting-edge automation paired with professional oversight. Our gateway 
            opens the door and provides access to a new world of trading possibilities – 
            without sacrificing control or transparency.
          </p>
        </Card>
      </div>
    </section>
  );
};

export default WhySection;
